export default {
	distributor: 1,
	retailer: 2
}